import PropTypes from "prop-types";
import React from 'react'
import { Link, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'

// Utilities
import Img from 'gatsby-image'
import kebabCase from 'lodash/kebabCase'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import Truncate from 'react-truncate'
import { SEO } from 'gatsby-theme-seo'


// Components
import Alert from '../svg/icons/alert'
import BlogLayout from '../components/layout/BlogLayout'
import TextScramble from '../components/TextScramble'
import DecryptTitle from "../components/decryptTitle";

import { INLINES, BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"



const PostExcerpt = ({ body }) => {

  return (
    <>
      {documentToReactComponents(body.json, {
        renderMark: {
          [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
          [MARKS.ITALIC]: text => <span className="italic]">{text}</span>,
          [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
          [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
        },
        renderNode: {
          [BLOCKS.HEADING_1]: (_node, children) => (
            <h1>{children}</h1>
          ),
          [BLOCKS.HEADING_2]: (_node, children) => (
            <h2>{children}</h2>
          ),
          [BLOCKS.HEADING31]: (_node, children) => (
            <h3>{children}</h3>
          ),
          [BLOCKS.HEADING_4]: (_node, children) => (
            <h4>{children}</h4>
          ),
          [BLOCKS.HEADING_5]: (_node, children) => (
            <h5>{children}</h5>
          ),
          [BLOCKS.HEADING_6]: (_node, children) => (
            <h6>{children}</h6>
          ),
          [BLOCKS.PARAGRAPH]: (_node, children) => <p className="text-left pb-3 break-words w-full">{children}</p>,
          [BLOCKS.QUOTE]: (_node, children) => <blockquote>{children}</blockquote>,
        },
      })}
    </>
  )
}

const DestaquePost = ({ data }) => {
  const { edges, group } = data.destaquePost

  

  return (
    <>
      {edges.map(({ node }) => {
        const { id, slug, title, body, featuredImage } = node

        return (
          <Link to={`/blog/${kebabCase(slug)}/`} id={`post-${kebabCase(id)}`}>
            <div className="w-full h-auto relative object-cover bg-white">
              <div className="absolute top-0 right-0 mr-4 lg:left-0 z-50 bg-white w-8 h-8 lg:w-16 lg:h-16 lg:ml-4 rounded-b lg:rounded-b-lg shadow-md">
                <Alert />
              </div>
              <Img 
                fluid={!featuredImage ? data.imageSharp.fluid : featuredImage.fluid} 
                className="absolute top-0 left-0 w-full h-auto"
                style={{maxHeight: 492}}
              />
              <div className="absolute bottom-0 left-0">
                
                <ul className="" id="meta"> 
                  {group.map(category => {
                    
                    return (
                      <li 
                        className="bg-white inline-block pr-1 lg:pr-2" >
                          <Link className="font-display text-sm uppercase text-criptoOrange-500 hover:text-black" to={`/categorias/${kebabCase(category.fieldValue)}/`}>
                            {category.fieldValue}
                          </Link>
                        </li>
                    )
                  })}
                  
                </ul>
              <h2 className="bg-white text-3xl lg:py-1 pr-1 lg:pr-2 text-criptoBlue-500 hover:text-black">
                <TextScramble>
                  {title}
                </TextScramble>
              </h2>
              </div>
              
            </div>
            <Truncate 
              lines={5} 
              ellipsis="(...)"
              >
              <div id="excerpt" className="mt-2 mb-3 font-light">
                <PostExcerpt body={body} />
              </div>
            </Truncate>
            <br />
            <Link to={`/blog/${kebabCase(slug)}`} className="font-display uppercase tracking-wider leia-mais lg:text-2xl text-base clear-left" >Ler mais</Link>
            
          </Link>
        )
      })}
    </>
  )
}

const SidePosts =({ data }) => {

  const { edges, group } = data.sidePosts

  return (
    <>
      {edges.map(({ node }) => {
        const { id, slug, title, featuredImage } = node

        return ( 
          <Link to={`/blog/${kebabCase(slug)}`} id={`post-${kebabCase(id)}`} >
            <div className="w-full mb-4 lg:mb-6 relative ">
              <Img 
                fluid={!featuredImage ? data.imageSharp.fluid : featuredImage.fluid } 
                className="absolute top-0 left-0 w-full h-auto"
                style={{maxHeight: 322}}
              />
              <h2 className="absolute bottom-0 left-0 bg-white break-words py-1 pr-1 lg:pr-2 text-sm lg:text-2xl text-criptoBlue-500 hover:text-black">
                <TextScramble>
                  {title}
                </TextScramble>
              </h2>
              <ul className="absolute top-0 right-0" id="meta">
                {group.map(category => {
                    return (
                      <li className=" lg:px-1 bg-white inline-block lg:pl-2" >
                        <Link className="font-display uppercase text-criptoOrange-500 hover:text-black text-sm pl-1 lg:pl-0 lg:text-base" to={`/categorias/${kebabCase(category.fieldValue)}/`}>
                          {category.fieldValue}
                        </Link>
                      </li>
                    )
                  })}
              </ul>
            </div>
          </Link>      
        )
      })}
    </>
  )
}

SidePosts.propTypes = {
  data: PropTypes.shape({
    imageSharp: PropTypes.shape({
      fluid: PropTypes.any
    }),
    sidePosts: PropTypes.any
  })
}

const CategoryCloud = ({
  data: { 
    categoryCloud: { 
     group 
    }, 
  },  
}) => {
  return (
    
    <ul className="items-center front-page-list pl-2">
    {group.map(categoria => (
      <li key={categoria.fieldValue}
        className="py-2 font-display uppercase font-light tracking-widest hover:text-criptoBlue-700">
        <AniLink 
          swipe
          direction="down"
          top="exit"
          to={`/categorias/${kebabCase(categoria.fieldValue)}/`}>
            {categoria.fieldValue} 
        </AniLink>
        
      </li>
    ))}
  </ul>
  )
}

const TagCloud = ({
  data: { 
    tagCloud: { 
     group 
    }, 
  },  
}) => {
  return (
    
    <ul className="items-center front-page-list pl-2">
    {group.map(tag => (
      <li key={tag.fieldValue}
        className="py-2 font-display uppercase font-light tracking-widest hover:text-criptoOrange-700">
        <AniLink 
          swipe
          direction="down"
          top="exit"
          to={`/tags/${kebabCase(tag.fieldValue)}/`}>
            {tag.fieldValue} 
        </AniLink>
        
      </li>
    ))}
  </ul>
  )
}

// BlogIndex Start
const BlogIndex = ({ data }) => {

  return (
  <BlogLayout kind="index" >
    <SEO title="Blog" />
    <div className="container mx-auto px-6 lg:px-0 mt-10 lg:pt-0">
      
      <div className="flex flex-wrap w-full h-auto border-b-1 pb-6 border-criptoBlue-400 border-b-1 ">  
        <div className=" w-full lg:w-3/5 h-full lg:pl-1 lg:pr-6" id="destaque">
          <h3 className="lg:text-3xl mb-1 lg:mb-3 -mt-4">
            <TextScramble>
              Em Destaque
            </TextScramble></h3>
          <DestaquePost data={data} />
          
        </div>
        <div className="w-full lg:w-2/5 mt-10 lg:pl-6 lg:pr-1" id="sidePosts">
        <SidePosts data={data} />
        </div>
      </div>
    
      <div className="flex flex-wrap w-full mt-6 lg:mt-12">
        <div className="w-full lg:w-1/3 cat-block pb-2 lg:pb-0 mb-6 lg:pr-12 lg:border-0 border-b-1">
          <h3 className="text-base lg:text-xl text-criptoBlue-800 border-gray-300 pb-3 border-0 lg:border-b-1 lg:pr-24 w-auto">
            Navegue por Categorias
          </h3>
          <CategoryCloud data={data} />
        </div>
        <div className="w-full lg:w-1/3 tag-block pb-2 lg:pb-0 mb-6 lg:pr-12 lg:border-0 border-b-1">
          <h3 className="text-base lg:text-xl text-criptoBlue-800 border-gray-300 pb-3 border-0 lg:border-b-1 lg:pr-24 w-auto">
            Navegue por Tags
          </h3>
          <TagCloud data={data} />
        </div>
        <div className="w-full lg:w-1/3 tag-block lg:pr-12">
          <DecryptTitle 
            data={data} 
            className="text-base lg:text-xl text-criptoBlue-800 border-gray-300 mb-2 w-auto" 
          />
          <div className="text-left font-light text-gray-600 tracking-wider hover:text-gray-700">
          {documentToReactComponents(data.contentfulPaginas.body.json, {
                renderMark: {
                  [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
                  [MARKS.ITALIC]: text => <span className="italic]">{text}</span>,
                  [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
                  [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
                },
                renderNode: {
                  [BLOCKS.HEADING_1]: (_node, children) => (
                    <h1>{children}</h1>
                  ),
                  [BLOCKS.HEADING_2]: (_node, children) => (
                    <h2>{children}</h2>
                  ),
                  [BLOCKS.HEADING31]: (_node, children) => (
                    <h3>{children}</h3>
                  ),
                  [BLOCKS.HEADING_4]: (_node, children) => (
                    <h4>{children}</h4>
                  ),
                  [BLOCKS.HEADING_5]: (_node, children) => (
                    <h5>{children}</h5>
                  ),
                  [BLOCKS.HEADING_6]: (_node, children) => (
                    <h6>{children}</h6>
                  ),
                  [INLINES.HYPERLINK]: (node, children) => {
                    return <Link to={node.data.uri} className="font-display uppercase tracking-wider text-gray-800 hover:text-criptoBlue-700">{children}</Link>
                  },
                  [BLOCKS.PARAGRAPH]: (_node, children) => <p className="mb-3">{children}</p>,
                  [BLOCKS.QUOTE]: (_node, children) => <blockquote>{children}</blockquote>,
                },
              })}
          </div>
          
        </div>
      </div>

    </div>
  </BlogLayout>
  )
}

export default BlogIndex

export const query = graphql`
  query {
    destaquePost:allContentfulBlogPost(
      sort: {
        order: DESC, 
        fields: date
      }, 
      limit: 1) {
      group(
        field: categoria___nome
      ) {
        fieldValue
      }
      edges {
        node {
          id
          slug
          title
          featuredImage {
            fluid(maxWidth: 600, quality: 90) {
              ...GatsbyContentfulFluid
            }
          }
          body {
            json
          }
        }
      }
    }
    sidePosts:allContentfulBlogPost(sort: {order: DESC, fields: date}, limit: 2, skip: 1) {
      group(field: categoria___nome) {
        fieldValue
      }
      edges {
        node {
          id
          slug
          title
          featuredImage {
            fluid(maxWidth: 600, quality: 90) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    },
    imageSharp(id: {eq: "2f858388-303c-53c6-a048-99a0354b7031"}) {
      fluid(maxWidth: 1200, toFormat: PNG) {
        ...GatsbyImageSharpFluid
      }
    },
    categoryCloud:allContentfulBlogPost(limit: 12) {
      group(field: categoria___nome) {
        fieldValue
      }
    },
    tagCloud:allContentfulBlogPost(limit: 12) {
      group(field: tags) {
        fieldValue
      }
    }
    contentfulPaginas(
      slug: {
        eq: "blog"
      }
    ) {
      titulo
      decrypt
      tituloDecrypt {
        textoNormal
        textoDecrypt
        posicionamento
      }
      body {
        json
      }
    }
  }
`